export enum TimePreferenceType {
  Work = 'work',
  Leisure = 'leisure',
}
